<script lang="ts">
	let name:string = 'world';

	import {onMount, getContext} from 'svelte';
	import {type Meeting, type AuthorizedResult, unauthorizedAccess, authorized} from './src/types';    
    import MeetingRow from './TeamMeetingRow.svelte';
    import { deleteMeeting, getSheets } from './src/client'
    import ConfirmDialog from './ConfirmDialog.svelte';
    import type { Context } from 'svelte-simple-modal';
    import {format, parse} from 'date-fns';
    import Fa from 'svelte-fa/src/fa.svelte';
    import { faDownload, faUpload, faBroom } from '@fortawesome/free-solid-svg-icons/index.js';
    import UploadSheetDialog from './uploadSheetDialog.svelte'
    import { push } from 'svelte-spa-router'
    import {Tooltip} from '@svelte-plugins/tooltips'
    import {season, team} from './store'

    const modal = getContext<Context>('simple-modal');
    
    const setAuthenticated = getContext<(b:boolean) => void>('setAuthenticated');

	export let currentTeam: string;

	export let currentSeason: string;

    export let guest : boolean | null | undefined;

    export let displaySheet : (id: number) => void  = (id:number) => {
        push(`/sheet/${id}`);
    };

	let meetings : Meeting[] = [];
    let meetingsFilter : string = '';

	export let params;

    const loadData:() => Promise<void> = getContext('loadData');
    
        $: {
            console.log(`reactive statement => getMeetings(${meetingsFilter})`);
            getMeetings(meetingsFilter).then(m => {
                if (m.authorized) {
                    meetings = m.result as Meeting[];
                }
                else {
                    setAuthenticated(false);
                    push('/login');
                    return;
                }
            });
        }

    const getMeetings = async (filter:string|undefined = undefined):Promise<AuthorizedResult<Meeting[]|undefined>> => {
        console.log(`getMeetings(${currentSeason}/${currentTeam}${filter ? `?filter=${filter}` : ''})`);
        let url = `team/${currentSeason}/${currentTeam}`;        
        if (filter && filter.length > 0) {
            url += `?filter=${filter}`;
        }
        console.log(`loading meetings from >${url}<`);
    	const response = await fetch(url);

        if (response.status == 401) {
            console.log(`unauthorized access while loading meetings for team ${currentSeason}/${currentTeam} with filter ${filter}`);
            setAuthenticated(false);
            return unauthorizedAccess();
        }		

		let meetings:Meeting[] = await response.json();
        console.log(`meetings loaded for team ${currentSeason}/${currentTeam} with filter ${filter} : ${meetings ? meetings.length : 'undefined'}`);
        meetings = meetings.filter(x => x !== null && x !== undefined);
		console.log(`meetings after filtering null/undefined for team ${currentSeason}/${currentTeam} with filter ${filter} : ${meetings ? meetings.length : 'undefined'}`);
		if (!meetings || meetings.length == 0) {
			const msg:string = `aucun matches pour l'équipe ${currentTeam} en ${currentSeason}'`;			
			return authorized([] as  Meeting[]);
		}
        
		return authorized(meetings);
	}

    onMount(async() => {
        currentTeam = (currentTeam === undefined ||currentTeam === null)  ? params.team : currentTeam;
        currentSeason = (currentSeason === undefined || currentSeason === null) ? params.season : currentSeason;
        guest = (guest === undefined || guest === null) ? false : guest;
        console.log(`onMount => getMeetings(${meetingsFilter})`);
        const m = await getMeetings(meetingsFilter);
        if (m.authorized) {
            meetings = m.result as Meeting[];
        }
        else {
            setAuthenticated(false);
            push('/login');
            return;
        }
    });

    const getScore = (meeting:Meeting):{team:number,opponent:number} => {
        let score = {
            team:0,
            opponent:0
        };
        for (let i = 0; i < meeting.matches.length; i++) {
            const match = meeting.matches[i];
            let delta = 1;
            if (meeting.coupe && match.double) {
                delta = 2
            }
            score.team += match.score.me > match.score.other ? delta : 0
            score.opponent += match.score.me > match.score.other ? 0 : delta
        }        
        return score;
    }

    const deleteMeets = async (meeting: Meeting) => {
        // suppression
        
        modal.open(ConfirmDialog,
            {
                message: `Voulez vous vraiment supprimer la rencontre  ${meeting.team} - ${currentTeam} du ${format(parse(meeting.date,'yyyy-MM-dd',new Date()),'dd / MM /yyyy')} ?`,                               
                onCancel:() => {},
                onOkay:async () => {
                   
                    let auth = await deleteMeeting(meeting.sheetId);
                    if (!auth.authorized) {
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                   
                    // rechargement
                    console.log(`after deletion => getMeetings(${meetingsFilter})`);
                    let m = await getMeetings(meetingsFilter);
                    if (m.authorized) {
                        meetings = m.result as Meeting[];
                    }
                    else {
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                }
            },
            {            
                closeButton: true,
                closeOnEsc: true,
                closeOnOuterClick: true
            });
        
    }

    const dlSheets = async (e: any) => {
        e.preventDefault();
        let sheets = await getSheets(currentSeason, currentTeam);
        if (!sheets.authorized) {
            setAuthenticated(false);
            push('/login');
            return;
        }
        let link = document.createElement('a')
        let blob = new Blob([JSON.stringify(sheets.result,null,2)], {type: 'application/json'});
	    let url = URL.createObjectURL(blob);        
        link.href = url;
        link.download = `${currentTeam.replace(' ','_')}-${currentSeason}.json`;        
        link.click();        
        URL.revokeObjectURL(url);
    }

const cleanSheets = async (e: any) => {
        e.preventDefault();
        modal.open(ConfirmDialog,
            {
                message: `Voulez vous vraiment supprimer tous les matchs de l'équipe ${currentTeam} en ${currentSeason} ?`,                               
                onCancel:() => {},
                onOkay:async () => {
                    console.log(`cleaning sheets for team ${currentSeason}/${currentTeam}`);
                    let auth = await fetch(`team/${currentSeason}/${currentTeam}/clean`, {method:'DELETE'});
                    if (!auth.ok) {
                        console.log(`error while cleaning sheets for team ${currentSeason}/${currentTeam} : ${auth.statusText}`);
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                    // rechargement
                    console.log(`after cleaning => getMeetings()`);
                    let m = await getMeetings('');
                    if (m.authorized) {
                        console.log(`meetings after cleaning : ${m.result ? (m.result as Meeting[]).length : 'undefined'}`);
                        meetings = m.result as Meeting[];
                    }
                    else {
                        console.log(`error while reloading meetings after cleaning sheets for team ${currentSeason}/${currentTeam} : ${m.authorized}`);
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                }
            },
            {            
                closeButton: true,
                closeOnEsc: true,
                closeOnOuterClick: true
            });
    }

    const importSheets = (e: any) => {
        e.preventDefault();
        modal.open(UploadSheetDialog,
            {
                onOkay:async () => {
                    await loadData();
                    // first we need to reload seasons and teams and select first for each
                    currentSeason = $season;
                    currentTeam = $team;
                    console.log(`after upload => getMeetings(${meetingsFilter})`);
                    const m = await getMeetings(meetingsFilter);

                    if (m.authorized) {
                        meetings = m.result as Meeting[];
                    }
                    else {
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                }
            },
            {            
                closeButton: true,
                closeOnEsc: true,
                closeOnOuterClick: true
            });
    }

</script>
{#if !guest}
<h1 style='text-align: center;font-style: italic;font-weight: bold;color: var(--color-secondary);'>{currentTeam} - {currentSeason}</h1>
<div style="display:flex;flex-direction:row;margin-left: auto;margin-right: auto;">
<Tooltip content="<b>Exporter les matchs</b><p>Télécharger les matchs pour les conserver.</p>" style={{ backgroundColor: 'blue', fontSize:'large'  }}
animation="puff"
position="left">
<h2 style="padding:1em"><a href="#" on:click={(e) => dlSheets(e)}><Fa icon="{faDownload}" size="3x"/>&nbsp;</a></h2>
</Tooltip>
<Tooltip content="<b>Importer des matchs</b><p>Envoyer des matchs précédemment exportés.</p>" style={{ backgroundColor: 'blue', fontSize:'large' }}
animation="puff"
position="right">
<h2 style="padding:1em"><a href="#" on:click={(e) => importSheets(e)}><Fa icon="{faUpload}" size="3x"/>&nbsp;</a></h2>
</Tooltip>
<Tooltip content="<b>Importer des matchs</b><p>Envoyer des matchs précédemment exportés.</p>" style={{ backgroundColor: 'blue', fontSize:'large' }}
animation="puff"
position="right">
<h2 style="padding:1em"><a href="#" on:click={(e) => cleanSheets(e)}><Fa icon="{faBroom}" size="3x"/>&nbsp;</a></h2>
</Tooltip>
</div>
{/if}
<input type="text" placeholder="filtrer les matchs" bind:value={meetingsFilter}/>
<div style="display:flex; flex-flow: row wrap">
    {#if meetings && meetings.length > 0} 
        {#each meetings as meeting (meeting.sheetId)}
            <MeetingRow guest={guest} meeting={meeting} final_score={getScore(meeting)} deleteMeeting={() => deleteMeets(meeting)} displaySheet={displaySheet}/>	
        {/each}
    {/if}
</div>